<template>
  <div id="chart_wrapper">
    <div class="options d-none d-sm-flex" style="direction: ltr;">
      <div class="d-flex align-center">
        <span class="options-item ms-2">Time</span>
        <div>
          <span
            class="options-item"
            v-for="(fav, index) in favorites"
            :key="index"
            @click="setInterval(fav.value)"
          >
            {{ fav.label }}
          </span>
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon v-bind="attrs" v-on="on" small>
                <v-icon clr="var(--v-gray2-base)">$arrowDown</v-icon>
              </v-btn>
            </template>

            <v-card color="gray10" class="pa-2">
              <v-row>
                <v-col cols="4">
                  <span class="gray2--text font-Regular-12">MINUTE</span>
                  <ul class="pl-0">
                    <li
                      class="time-scale-item"
                      v-for="(item, index) in timeScales.min"
                      :key="index"
                    >
                      <span @click="setInterval(item.value)">{{
                        item.label
                      }}</span>
                      <v-btn icon small @click.stop="toggleFavorite(item)">
                        <v-icon
                          size="20"
                          :backClr="
                            favorites.some((f) => f.value === item.value)
                              ? 'yellow'
                              : ''
                          "
                          :clr="favorites.includes(item.value) ? 'yellow' : ''"
                        >
                          $favoriteStar
                        </v-icon>
                      </v-btn>
                    </li>
                  </ul>
                </v-col>
                <v-col cols="4">
                  <span class="gray2--text font-Regular-12">HOUR</span>
                  <ul class="pl-0">
                    <li
                      v-for="(item, index) in timeScales.hr"
                      :key="index"
                      class="time-scale-item"
                    >
                      <span @click="setInterval(item.value)">{{
                        item.label
                      }}</span>
                      <v-btn icon small @click.stop="toggleFavorite(item)">
                        <v-icon
                          size="20"
                          :backClr="
                            favorites.some((f) => f.value === item.value)
                              ? 'yellow'
                              : ''
                          "
                          :clr="favorites.includes(item.value) ? 'yellow' : ''"
                        >
                          $favoriteStar
                        </v-icon>
                      </v-btn>
                    </li>
                  </ul>
                </v-col>
                <v-col cols="4">
                  <span class="gray2--text font-Regular-12">DAY</span>
                  <ul class="pl-0">
                    <li
                      class="time-scale-item"
                      v-for="(item, index) in timeScales.day"
                      :key="index"
                    >
                      <span @click="setInterval(item.value)">{{
                        item.label
                      }}</span>
                      <v-btn icon small @click.stop="toggleFavorite(item)">
                        <v-icon
                          size="20"
                          :backClr="
                            favorites.some((f) => f.value === item.value)
                              ? 'yellow'
                              : ''
                          "
                          :clr="favorites.includes(item.value) ? 'yellow' : ''"
                        >
                          $favoriteStar
                        </v-icon>
                      </v-btn>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-card>
          </v-menu>
        </div>
        <div class="mx-8">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openIndicators"
                icon
                v-bind="attrs"
                v-on="on"
                x-small
                class="ms-2"
              >
                <v-icon clr="var(--v-gray2-base)">$indicators</v-icon>
              </v-btn>
            </template>
            <span>Indicators</span>
          </v-tooltip>

          <v-menu offset-y :close-on-content-click="true" open-on-hover>
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon v-bind="attrs" v-on="on" small class="ms-2">
                <v-icon clr="var(--v-gray2-base)">{{
                  selectedChartType.icon
                }}</v-icon>
              </v-btn>
            </template>

            <!-- <v-card color="gray10" class="pa-2"> -->
            <v-list dense color="gray10">
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, i) in chartTypes"
                  :key="i"
                  @click="selectChartType(item)"
                >
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <!-- </v-card> -->
          </v-menu>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="takeScreenshot"
                icon
                v-bind="attrs"
                v-on="on"
                x-small
                class="ms-2"
              >
                <v-icon clr="var(--v-gray2-base)">$photo</v-icon>
              </v-btn>
            </template>
            <span>Screenshot</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ms-2"
                @click="resetChart"
                icon
                v-bind="attrs"
                v-on="on"
                x-small
              >
                <v-icon clr="var(--v-gray2-base)">$reset</v-icon>
              </v-btn>
            </template>
            <span>Reset Chart</span>
          </v-tooltip>
        </div>
      </div>
      <div>
        <span
          v-for="(item, index) in chartTypeTab"
          :key="index"
          class="options-item"
          :class="{ 'primary--text': selectedChartTypeTab === item.value }"
          @click="changeSelectedChartTab(item.value)"
        >
          {{ item.title }}
        </span>

        <v-btn
          v-if="isFullscreen"
          @click="exitFullscreenMethod"
          icon
          v-bind="attrs"
          v-on="on"
          x-small
          class="me-2"
        >
          <v-icon clr="var(--v-gray2-base)">$exitFullscreen</v-icon>
        </v-btn>
        <v-btn
          v-else
          @click="fullscreenMethod"
          icon
          v-bind="attrs"
          v-on="on"
          x-small
          class="me-2"
        >
          <v-icon clr="var(--v-gray2-base)">$fullscreen</v-icon>
        </v-btn>
      </div>
    </div>
    <div ref="captureSection" id="tv_chart_container"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { MarketMarketService } from "@/services";
var Stomp = require("stompjs");
var SockJS = require("sockjs-client");

const supported_resolutions = [
  "1",
  "5",
  "15",
  "30",
  "60",
  "240",
  "1D",
  "1W",
  "1M",
];

const intervalMap = {
  "1min": "1",
  "5min": "5",
  "15min": "15",
  "30min": "30",
  "1hour": "60",
  "4hour": "240",
  "1day": "1D",
  "1week": "1W",
  "1month": "1M",
};

export default {
  name: "TradingViewChartNew",
  props: {
    symbol: {
      type: String,
      default: "BTCUSDT",
    },
    coinScale: {
      type: Number,
      default: 8,
    },
    chartTypeTab: {
      type: Array,
    },
    selectedChartTypeTab: {
      type: String,
      default: "trading-view",
    },
    // loading: {
    //   type: Boolean
    // }
  },
  data() {
    return {
      favorites: [
        { label: "1m", value: "1" },
        { label: "5m", value: "5" },
        { label: "1h", value: "60" },
        { label: "1D", value: "1D" },
      ],
      subscription: {},
      widget: null,
      interval: "1day",
      datafeed: null,
      lastBar: null,
      currentBar: null,
      onRealtimeCallback: null,
      subscriberUID: null,
      timeScales: {
        min: [
          // { label: "1s", value: "1s" },
          { label: "1m", value: "1" },
          // { label: "3m", value: "3m" },
          { label: "5m", value: "5" },
          { label: "15m", value: "15" },
          { label: "30m", value: "30" },
        ],
        hr: [
          { label: "1h", value: "60" },
          // { label: "2h", value: "240" },
          { label: "4h", value: "240" },
          // { label: "6h", value: "5m" },
          // { label: "8h", value: "8h" },
          // { label: "12h", value: "12h" }
        ],
        day: [
          { label: "1D", value: "1D" },
          // { label: "3D", value: "3D" },
          { label: "1W", value: "1W" },
          { label: "1M", value: "1M" },
        ],
      },
      chartTypes: [
        { text: "Bars", value: 0, icon: "$bars" },
        { text: "Candles", value: 1, icon: "$candles" },
        { text: "Line", value: 2, icon: "$line" },
        { text: "Area", value: 3, icon: "$area" },
        // { text: "Renko", value: 4, icon: "$renko" },
        // { text: "Kagi", value: 5, icon: "$kagi" },
        // { text: "Point & Figure", value: 6, icon: "$pnf" },
        // { text: "Line Break", value: 7, icon: "$lineBreak" },
        { text: "Heikin Ashi", value: 8, icon: "$heikinAshi" },
        { text: "Hollow Candles", value: 9, icon: "$hollowCandles" },
        { text: "Baseline", value: 10, icon: "$baseline" },
        { text: "High-Low", value: 12, icon: "$highLow" },
        { text: "Columns", value: 13, icon: "$columns" },
        { text: "Line with markers", value: 14, icon: "$lineWithMarkers" },
        { text: "Step line", value: 15, icon: "$stepLine" },
        { text: "HLC Area", value: 16, icon: "$hlcArea" },
        { text: "Volume Candles", value: 19, icon: "$candles" },
        { text: "HLC Bars", value: 21, icon: "$hlcBars" },
      ],
      selectedChartType: { text: "Bars", value: 0, icon: "$bars" },
      isFullscreen: false,
    };
  },
  mounted() {
    this.loadScripts().then(() => {
      this.initChart();
    });
    const savedFavs = localStorage.getItem("timeframe-favorites");
    if (savedFavs) {
      this.favorites = JSON.parse(savedFavs);
    }
  },
  watch: {
    "$vuetify.theme.dark": {
      handler() {
        this.widget.changeTheme(this.$vuetify.theme.dark ? "dark" : "light");
        this.initChart();
      },
      immediate: false,
    },
  },
  methods: {
    ...mapActions({
      getKLineData: "tradingView/GET_KLINES_DATA",
    }),
    openIndicators() {
      if (this.widget && this.widget.chart) {
        this.widget.chart().executeActionById("insertIndicator");
      }
    },

    toggleFavorite(item) {
      const exists = this.favorites.find((f) => f.value === item.value);
      if (exists) {
        this.favorites = this.favorites.filter((f) => f.value !== item.value);
      } else {
        if (this.favorites.length < 4) {
          this.favorites.push(item);
        } else {
          this.favorites.splice(0, 1); // اولین رو حذف کن
          this.favorites.push(item);
          console.log(this.favorites);
        }
      }
      localStorage.setItem(
        "timeframe-favorites",
        JSON.stringify(this.favorites)
      );
    },
    setInterval(tf) {
      this.interval = tf;
      if (this.widget && this.widget.chart) {
        this.widget.chart().setResolution(tf, () => {});
      }
    },

    async takeScreenshot() {
      const screenshotCanvas = await this.widget.takeClientScreenshot();
      const linkElement = document.createElement("a");
      linkElement.download = "screenshot.png";
      linkElement.href = screenshotCanvas.toDataURL(); // Or use toBlob for better performance
      linkElement.dataset.downloadurl = [
        "image/png",
        linkElement.download,
        linkElement.href,
      ].join(":");

      document.body.appendChild(linkElement);
      linkElement.click();
      document.body.removeChild(linkElement);
    },

    resetChart() {
      localStorage.removeItem("tradingview_layout");
      if (this.widget) {
        this.widget.remove();
      }
      this.initChart();
    },
    fullscreenMethod() {
      const elem = document.getElementById("chart_wrapper");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        // Safari
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        // IE/Edge
        elem.msRequestFullscreen();
      }

      this.isFullscreen = true;
    },
    exitFullscreenMethod() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        // Safari
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
      this.isFullscreen = false;
    },

    getParameterByName(name) {
      name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
      const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(window.location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    },

    loadScripts() {
      const script1 = this.loadScript(
        "/charting_library/charting_library.standalone.js"
      );
      return Promise.all([script1]);
    },

    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    createDatafeed() {
      const self = this;
      return {
        onReady: (callback) => {
          setTimeout(
            () =>
              callback({
                supported_resolutions,
                supports_marks: false,
                supports_timescale_marks: false,
                supports_time: true,
              }),
            0
          );
        },

        searchSymbols: (
          userInput,
          exchange,
          symbolType,
          onResultReadyCallback
        ) => {
          onResultReadyCallback([]);
        },

        resolveSymbol: (
          symbolName,
          onSymbolResolvedCallback
          // onResolveErrorCallback
        ) => {
          const symbolInfo = {
            name: self.symbol.toUpperCase(),
            full_name: self.symbol.toUpperCase(),
            description: self.symbol.toUpperCase(),
            type: "crypto",
            session: "24x7",
            exchange: "Excoino",
            pricescale: Math.pow(10, self.coinScale),
            listed_exchange: self.symbol,
            timezone: "Asia/Tehran",
            format: "price",
            minmov: 1,
            has_intraday: true,
            supported_resolutions,
            has_weekly_and_monthly: true,
            volume_precision: 2,
          };

          setTimeout(() => onSymbolResolvedCallback(symbolInfo), 0);
        },

        getBars: async (
          symbolInfo,
          resolution,
          periodParams,
          onHistoryCallback,
          onErrorCallback
        ) => {
          const { from, to, firstDataRequest } = periodParams;

          if (!firstDataRequest) {
            onHistoryCallback([], { noData: true });
            return;
          }

          if (resolution !== intervalMap[self.interval]) {
            self.unsubscribeKLine();
            for (const key in intervalMap) {
              if (intervalMap[key] === resolution) {
                self.interval = key;
              }
            }
          }

          try {
            const size = window.innerWidth;
            // const res = await self.getKLineData({
            //   symbol: self.symbol,
            //   from: from * 1000,
            //   to: firstDataRequest ? new Date().getTime() : to * 1000,
            //   resolution: intervalMap[self.interval],
            //   size: size > 2000 ? 2000 : size
            // });
            const res = await MarketMarketService.getKLineData({
              symbol: self.symbol,
              from: from * 1000,
              to: firstDataRequest ? new Date().getTime() : to * 1000,
              resolution: intervalMap[self.interval],
              size: size > 2000 ? 2000 : size,
            });

            if (
              resolution === intervalMap[self.interval] &&
              firstDataRequest &&
              res.data &&
              res.data.length
            ) {
              self.subscribeKLine(self.interval);
            }
            const newTheme = this.$vuetify.theme.dark ? "dark" : "light";

            if (this.widget) {
              this.widget.changeTheme(newTheme);

              const overrides =
                newTheme === "dark"
                  ? {
                      "paneProperties.background": "#1E252F",
                      "paneProperties.backgroundType": "solid",
                    }
                  : {
                      "paneProperties.background": "#FFFFFF",
                      "paneProperties.backgroundType": "solid",
                    };

              this.widget.applyOverrides(overrides);
            }

            self.$emit("chartsLoading");

            if (!res.data || !res.data.length) {
              onHistoryCallback([], { noData: true });
              return;
            }

            const bars = [];
            for (let i = 0; i < res.data.length; i++) {
              const item = res.data[i];
              let time = item[0];

              if (resolution === "1D") {
                time = item[0] + 12600000;
              } else if (resolution === "1W") {
                time = item[0] + 99000000;
              } else if (resolution === "1M") {
                time = item[0] + 16200000;
              }

              bars.push({
                time: time,
                open: item[1],
                high: item[2],
                low: item[3],
                close: item[4],
                volume: item[5],
              });
            }

            bars.sort((l, r) => (l.time > r.time ? 1 : -1));

            if (bars.length > 0) {
              self.lastBar = bars[bars.length - 1];
            }

            onHistoryCallback(bars, { noData: !bars.length });
          } catch (error) {
            console.error("Error fetching bars:", error);
            onErrorCallback(error);
          }
        },

        subscribeBars: (
          symbolInfo,
          resolution,
          onRealtimeCallback,
          subscriberUID
          // onResetCacheNeededCallback
        ) => {
          self.onRealtimeCallback = onRealtimeCallback;
          self.subscriberUID = subscriberUID;
        },

        unsubscribeBars: () => {
          self.unsubscribeKLine();
          self.onRealtimeCallback = null;
          self.subscriberUID = null;
        },

        updateKLine: (bar) => {
          if (self.onRealtimeCallback) {
            self.onRealtimeCallback(bar);
          }
        },
      };
    },

    initChart() {
      if (window.TradingView) {
        this.datafeed = this.createDatafeed();

        const widget = new window.TradingView.widget({
          fullscreen: true,
          autosize: true,
          height: 320,
          symbol: this.symbol.toUpperCase(),
          interval: intervalMap[this.interval],
          container: "tv_chart_container",
          datafeed: this.datafeed,
          library_path: "/charting_library/",
          locale: this.getParameterByName("lang") || "en",
          timezone: "Asia/Tehran",
          time_frames: [],
          disabled_features: [
            "use_localstorage_for_settings",
            "header_compare",
            this.$vuetify.breakpoint.width > 600 ? "header_widget" : null,
          ],
          enabled_features: ["study_templates"],
          studies_overrides: { "volume.show ma": true },
          debug: false,
          toolbar_bg: this.$vuetify.theme.dark ? "#282F38" : "",
          theme: this.$vuetify.theme.dark ? "dark" : "light",

          overrides: this.$vuetify.theme.dark
            ? {
                "paneProperties.background": "#1E252F",
                "paneProperties.backgroundType": "solid",
              }
            : {},
        });

        this.widget = widget;

        widget.onChartReady(() => {
          // بارگذاری تنظیمات ذخیره شده از localStorage
          const savedLayout = localStorage.getItem("tradingview_layout");
          if (savedLayout) {
            try {
              const parsed = JSON.parse(savedLayout);
              widget.load(parsed);
            } catch (e) {
              localStorage.removeItem("tradingview_layout");
            }
          }

          const chart = widget.chart();

          const saveLayout = () => {
            if (typeof widget.save === "function") {
              try {
                widget.save((data) => {
                  try {
                    localStorage.setItem(
                      "tradingview_layout",
                      JSON.stringify(data)
                    );
                    console.log("Saved chart layout");
                  } catch (err) {
                    console.error("Failed to save layout", err);
                  }
                });
              } catch (err) {
                console.warn("widget.save() not ready", err);
              }
            }
          };

          // ذخیره در localStorage وقتی interval یا symbol تغییر می‌کند
          chart.onIntervalChanged().subscribe(null, saveLayout);
          chart.onSymbolChanged().subscribe(null, saveLayout);

          // ذخیره هر 10 ثانیه به صورت خودکار
          setInterval(saveLayout, 10000);
        });
      }
    },

    subscribeKLine(resolution) {
      let stompClient = null;
      let socket = new SockJS(
        `${process.env.VUE_APP_BASE_MARKET}/market/market-ws`
        // `https://market-api.excoino.com/market/market-ws`
      );
      stompClient = Stomp.over(socket);
      stompClient.debug = false;
      stompClient.connect({}, () => {
        this.subscription = stompClient.subscribe(
          "/topic/market/kline/" + this.symbol + "/" + resolution,
          (msg) => {
            const resp = JSON.parse(msg.body);
            let time = resp.time;

            if (resolution === "1day") {
              time = resp.time + 12600000;
            } else if (resolution === "1week") {
              time = resp.time + 99000000;
            } else if (resolution === "1month") {
              time = resp.time + 16200000;
            }

            const bar = {
              time: time,
              open: resp.openPrice,
              high: resp.highestPrice,
              low: resp.lowestPrice,
              close: resp.closePrice,
              volume: resp.volume,
            };

            this.lastBar = bar;
            this.currentBar = bar;

            if (this.datafeed && this.datafeed.updateKLine) {
              this.datafeed.updateKLine(bar);
            }
          }
        );
      });

      if (!this.stompSocket) return;

      // this.subscription = stompClient.subscribe.subscribe(
      //   "/topic/market/kline/" + this.symbol + "/" + resolution,
      //   msg => {
      //     const resp = JSON.parse(msg.body);
      //     let time = resp.time;
      //
      //     if (resolution === "1day") {
      //       time = resp.time + 12600000;
      //     } else if (resolution === "1week") {
      //       time = resp.time + 99000000;
      //     } else if (resolution === "1month") {
      //       time = resp.time + 16200000;
      //     }
      //
      //     const bar = {
      //       time: time,
      //       open: resp.openPrice,
      //       high: resp.highestPrice,
      //       low: resp.lowestPrice,
      //       close: resp.closePrice,
      //       volume: resp.volume
      //     };
      //
      //     this.lastBar = bar;
      //     this.currentBar = bar;
      //
      //     if (this.datafeed && this.datafeed.updateKLine) {
      //       this.datafeed.updateKLine(bar);
      //     }
      //   }
      // );
    },

    unsubscribeKLine() {
      if (this.subscription && this.subscription.unsubscribe) {
        this.subscription.unsubscribe();
      }
    },

    selectChartType(chartType) {
      this.selectedChartType = chartType;
      if (this.widget && this.widget.chart) {
        const chart = this.widget.chart();
        chart.setChartType(chartType.value); // این تابع TradingView هست
      }
    },

    changeSelectedChartTab(value) {
      this.$emit("changeTab", value);
    },
  },

  beforeDestroy() {
    this.unsubscribeKLine();
    if (this.widget) {
      this.widget.remove();
    }
  },
};
</script>

<style scoped lang="scss">
.time-scale-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70px !important;
  padding: 4px;
  cursor: pointer;
  &:hover {
    background: var(--v-gray8-base);
  }
}
</style>
